import './Popup.scss';

import React from 'react';

const Popup = ({ title, textContent, closePopup }) => {
  return (
    <div className="popup">
      <div className="popup-header">
        <h1>
          <strong>{title}</strong>
        </h1>
        <p
          onClick={(event) => {
            event.preventDefault();
            closePopup();
          }}
        >
          <strong style={{ color: '#1D364C' }}>Cerrar X</strong>
        </p>
      </div>
      <div className="popup-content">{textContent}</div>
    </div>
  );
};

export default Popup;
